import { useEffect } from 'react';
import { Platform } from 'react-native';

const MIN_HEIGHT = 800;
let currentDocumentHeight = 0;

const sendMessageUpdatingHeight = (height: number) => {
  window.parent.postMessage(
    { eventName: 'SET_HEIGHT', payload: { height } },
    '*'
  );
};

const handleDocumentMutation = () => {
  let documentHeight = document.body.scrollHeight;
  const previousScroll = window.scrollY;

  if (documentHeight > MIN_HEIGHT) {
    currentDocumentHeight = MIN_HEIGHT;
    sendMessageUpdatingHeight(MIN_HEIGHT);
    setTimeout(() => {
      documentHeight = document.body.scrollHeight;
      if (documentHeight && documentHeight !== MIN_HEIGHT) {
        currentDocumentHeight = documentHeight;
        sendMessageUpdatingHeight(documentHeight);
      }
      window.scrollTo(0, previousScroll);
    }, 100);
  } else {
    if (MIN_HEIGHT !== currentDocumentHeight) {
      currentDocumentHeight = MIN_HEIGHT;
      sendMessageUpdatingHeight(MIN_HEIGHT);
      window.scrollTo(0, previousScroll);
    }
  }
};

export const useWebDocumentHeight = () => {
  useEffect(() => {
    if (Platform.OS === 'web') {
      if (window.location !== window.parent.location) {
        setTimeout(() => {
          handleDocumentMutation();
          const observer = new MutationObserver(handleDocumentMutation);

          observer.observe(document.body, {
            subtree: true,
            attributes: false,
            childList: true,
            characterData: false,
          });
          return () => observer.disconnect();
        }, 500);
      }
    }
  }, []);
};
